// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as StockTransferForm from "./StockTransferForm.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function StockTransferFormSenderInformationCard(props) {
  let shops = Auth.useShops();
  let formState = StockTransferForm.useFormState();
  let items = shops.map(shop => ({
    TAG: "Option",
    key: shop.id,
    label: shop.name,
    value: shop.id,
    disabled: shop.id === formState.values.recipientShopId
  }));
  let sections = [{
      items: items
    }];
  return JsxRuntime.jsx(Card.make, {
    children: JsxRuntime.jsx(Stack.make, {
      children: JsxRuntime.jsx(StockTransferForm.InputSelect.make, {
        field: "SenderShopId",
        label: I18n.t("Sender"),
        tooltip: JsxRuntime.jsx(Tooltip.Span.make, {
          text: I18n.t("Changing the sender will reset the transfer basket.")
        }),
        placeholder: I18n.t("Select the sending shop"),
        sections: sections
      }),
      space: "large"
    }),
    title: I18n.t("Sender information"),
    grow: true
  });
}

let make = React.memo(StockTransferFormSenderInformationCard);

export {
  make,
}
/* make Not a pure module */
